import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import Loader from "../../components/base/Loader";
import { useAuth } from "../../contexts/AuthContext";
import { loginWithGoogle } from "../../api/auth";

const GoogleAuthPage = () => {
    const navigate = useNavigate();
    const { setIsLoggedIn, refreshAuth } = useAuth()

    // 현재 브라우저 URL에서 쿼리 파라미터 추출
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code"); // ?code=xxxxxx 부분

    useEffect(() => {
      const handleGoogleLogin = async () => {
          if (!code) return;

          
  
          try {
              // 1. 서비스 호출
              const data = await loginWithGoogle(code);
  
              // 2. 성공 처리
              if (data?.success && data?.status === "OK") {
                const userData = await refreshAuth();

                if (userData) {
                  if (!userData.has_store || !userData.has_channel) {
                    navigate("/onboarding", { replace: true });
                  } else {
                    navigate("/stores", { replace: true });
                  }
                }

              } else if (data?.success && data?.status === "REGISTERED") {
                const userData = await refreshAuth();

                if (userData) {
                  navigate("/onboarding", { replace: true });
                }
                
              
              } else {
                alert("오류 발생: 인증 결과가 올바르지 않습니다.");
                navigate("/auth/login");
              }
          } catch (err) {
              // 3. 에러 발생 시 처리
              alert("로그인 중 오류가 발생했습니다.");
              navigate("/auth/login");
          }
      };
  
      handleGoogleLogin();
    }, [code, navigate, setIsLoggedIn, refreshAuth]);

    return (
      <div
        style={{
          width: "100%",
          height: "100vh", // 화면 전체 높이
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* <span>code: {code}</span> */}
        {/* <Loader color="#5751FFCC"/> */}
        <span>
          로딩 중...
        </span>
      </div>
    );
};

export default GoogleAuthPage;
